import { flow, mapValues, omit, partialRight } from 'lodash';

let delimiter = '_';

const generateAsyncActionTypes = (type) => {
  const TYPE = type;
  const PENDING = `${type}${delimiter}PENDING`;
  const SUCCESS = `${type}${delimiter}SUCCESS`;
  const FAILURE = `${type}${delimiter}FAILURE`;
  const CANCELLED = `${type}${delimiter}CANCELLED`;

  return {
    TYPE,
    PENDING,
    SUCCESS,
    FAILURE,
    CANCELLED,
  };
};

const setDelimiter = (newDelimiter) => {
  delimiter = newDelimiter;
};

const getDelimiter = () => delimiter;

const availableStatuses = flow(
  partialRight(omit, ['TYPE']),
  partialRight(mapValues, (value, key) => key)
)(generateAsyncActionTypes());

export { getDelimiter, setDelimiter, availableStatuses };
export default generateAsyncActionTypes;
